{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "ProfileSettingsDefinitions",
  "definitions": {
    "NotifyChannels": {
      "description": "Delivery channels for a single notification type.",
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "email": {
          "description": "Deliver this notification by email.",
          "type": "boolean",
          "default": true
        },
        "sms": {
          "description": "Deliver this notification by SMS.",
          "type": "boolean",
          "default": false
        },
        "push": {
          "description": "Deliver this notification by push notification.",
          "type": "boolean",
          "default": false
        }
      }
    },
    "ProfileSettingsSchema": {
      "description": "Settings for a profile",
      "type": "object",
      "required": [
        "id",
        "created_by",
        "created_at",
        "deleted_by",
        "deleted_at",
        "profile_id",
        "about",
        "logo_path",
        "billing_address_id"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "created_by": {
          "type": "string"
        },
        "created_at": {
          "type": "string",
          "format": "date-time"
        },
        "deleted_by": {
          "type": ["string", "null"],
          "format": "uuid",
          "default": null
        },
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time",
          "default": null
        },
        "profile_id": {
          "type": "string",
          "description": "This is directly mapped to id"
        },
        "about": {
          "description": "Short description of this profile",
          "type": ["string", "null"],
          "default": null
        },
        "logo_path": {
          "description": "The logo to be used on invoices",
          "type": ["string", "null"],
          "default": null
        },
        "billing_address_id": {
          "description": "The billing address to be used on invoices",
          "type": ["string", "null"],
          "default": null
        },
        "payment_provider_integration_id": {
          "description": "The integration to use as the payment provider. Null means in-built/manual.",
          "type": ["string", "null"],
          "format": "uuid",
          "default": null
        },
        "notify_weekly_digest": {
          "$ref": "#/definitions/NotifyChannels"
        },
        "tax_registered": {
          "description": "Whether the teacher is registered for VAT or another sales tax. When false no tax identity appears on invoices and prices carry no tax.",
          "type": "boolean",
          "default": false
        },
        "tax_scheme": {
          "description": "The sales tax scheme the teacher is registered under. Must not be 'none' when tax_registered is true.",
          "type": "string",
          "enum": ["vat", "gst", "sales_tax", "none"],
          "default": "none"
        },
        "tax_country": {
          "description": "The country the teacher is registered for tax in, as an ISO 3166-1 alpha-2 code like GB. Decides how the tax number is checked.",
          "type": ["string", "null"],
          "default": null
        },
        "tax_id_label": {
          "description": "The label shown before the tax number on invoices, like 'VAT No.'.",
          "type": ["string", "null"],
          "maxLength": 100,
          "default": null
        },
        "tax_id_value": {
          "description": "The tax registration number shown on invoices, like 'GB 123 4567 89'.",
          "type": ["string", "null"],
          "maxLength": 100,
          "default": null
        },
        "company_number": {
          "description": "The company registration number of a limited company, shown on invoices when set.",
          "type": ["string", "null"],
          "maxLength": 100,
          "default": null
        },
        "show_tax_on_invoice": {
          "description": "When tax details appear on invoices.",
          "type": "string",
          "enum": ["always", "when_registered", "never"],
          "default": "when_registered"
        }
      }
    }
  }
}
